import { useMemo } from 'react';

import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';

export const DEFAULT_HEADING = 'For illustrative purposes only';
export const DEFAULT_BODY =
  'This presentation is a hypothetical analysis used for illustrative purposes and should not be construed as legal or tax advice. Neither the information nor any opinion expressed constitutes a solicitation for the purchase or sale of any security or other instrument.';

export interface DisclaimerConfiguration {
  presentationCoverDisclaimerTitle: string;
  presentationCoverDisclaimerBody: string;
  presentationFooterDisclaimerTitle: string;
  presentationFooterDisclaimerBody: string;
  presentationStandaloneDisclaimerTitle: string;
  presentationStandaloneDisclaimerBody: string;
}

const DEFAULT_DISCLAIMER_CONFIGURATION: DisclaimerConfiguration = {
  presentationCoverDisclaimerTitle: DEFAULT_HEADING,
  presentationCoverDisclaimerBody: DEFAULT_BODY,
  presentationFooterDisclaimerTitle: DEFAULT_HEADING,
  presentationFooterDisclaimerBody: DEFAULT_BODY,
  presentationStandaloneDisclaimerTitle: 'Legal disclaimer', // will be overridden in the hook below
  presentationStandaloneDisclaimerBody: '',
};

export function useDefaultDisclaimerConfiguration(): DisclaimerConfiguration {
  const { displayName } = useTenantDetailsContext();
  return useMemo(
    () => ({
      ...DEFAULT_DISCLAIMER_CONFIGURATION,
      presentationStandaloneDisclaimerTitle: `${displayName} legal disclaimer`,
    }),
    [displayName]
  );
}
